const buttonClasses = 'bg-secondaryPurple-600 text-white';

const buttonHoverClasses = 'hover:bg-secondaryPurple-900';

const buttonIconClasses = 'fill-white';

const buttonSecondaryPurpleClasses = {
  buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses],
  buttonIconClasses,
};

export default buttonSecondaryPurpleClasses;
